<div class="flex flex-col h-full flex-1 relative">
	<div class="px-4 flex justify-between">
		<div class="flex items-end my-4">
			<h2>Requisitions</h2>
			<atomic-button-dropdown
				data-intercom-target="add-requisition-dropdown"
				class="ml-4"
				[icon]="ICON.ADD"
				[itemGroups]="[{ items: dropdownItems }]"
				(onSelect)="onSelect($event)"
				size="small"
				[testHook]="testHooks.ButtonDropdown"
				>Add new</atomic-button-dropdown
			>
		</div>

		<label
			class="text-green underline cursor-pointer ml-5 flex items-center mt-2 text-lg"
			(click)="toggleDetails()"
			>{{ showDetails ? 'Hide details' : 'Show details' }}</label
		>
	</div>

	<div [@openClose] *ngIf="showDetails">
		<app-container type="dark" class="m-2">
			<div class="flex justify-between items-end gap-4">
				<div class="flex gap-4 items-end">
					<app-date-picker
						[ngModel]="titleSearchCompletionDate"
						(ngModelChange)="setRequisitionDate($event)"
						label="Requisition date"
						[testHook]="testHooks.RequisitionDateDatePicker"
					></app-date-picker>
					<app-date-picker
						[ngModel]="requisitionStatus?.requisitionLetterDate"
						(ngModelChange)="setRequisitionLetterDate($event)"
						label="Date of requisition letter"
						[testHook]="testHooks.DateOfRequisitionLetterDatePicker"
					></app-date-picker>
				</div>

				<app-checkbox
					[ngModel]="requisitionStatus?.uploaded"
					(ngModelChange)="setRequisitionUploaded($event)"
					[testHook]="testHooks.SetRequisitionUploadCheckbox"
				>
					Submitted Requisition letter
				</app-checkbox>
			</div>
		</app-container>
	</div>

	<div class="flex min-h-0 flex-1">
		<div
			class="w-1/2 p-2 draggable-list h-full overflow-y-auto"
			cdkDropList
			(cdkDropListDropped)="drop($event)"
		>
			<app-container
				cdkDrag
				type="dark"
				[cdkDragData]="requisition"
				*ngFor="let requisition of requisitions; trackBy: trackByRequisitionId"
				class="mb-4 draggable-item"
			>
				<div class="flex justify-between">
					<div class="flex items-center">
						<div class="flex items-center">
							<app-icon
								cdkDragHandle
								[icon]="ICON.SORT"
								class="text-grey-light hover:text-grey-darker cursor-pointer draggable-item mr-2"
							></app-icon>
							<h4 class="m-0">
								<ng-container *ngIf="requisition?.title; else noTitle">{{
									requisition.title
								}}</ng-container>
								<ng-template #noTitle
									>{{ requisition?.name }}
									{{
										requisition?.fields?.instrumentNumber?.value ??
											requisition?.fields?.ownerName?.value
									}}</ng-template
								>
							</h4>
						</div>

						<app-icon
							[icon]="ICON.EDIT"
							class="ml-4 cursor-pointer"
							(click)="updateRequisition(requisition.id)"
							[testHook]="testHooks.UpdateRequisitionIcon"
						></app-icon>
					</div>
					<app-button
						btn="tertiary"
						[holdable]="true"
						[icon]="ICON.DELETE"
						(onClick)="onDelete(requisition.id)"
						class="mL-4 text-grey-light hover:text-grey-darker"
						[testHook]="testHooks.DeleteButton"
					></app-button>
				</div>

				<app-requisition-precedent-data
					[requisition]="requisition"
				></app-requisition-precedent-data>
			</app-container>
		</div>
		<div class="w-1/2 h-full flex flex-col">
			<ng-container
				*ngIf="requisitionsDocSourceIdByMatterType$ | async as sourceId"
			>
				<app-documents-word-matter-viewer
					*ngIf="!(useHtmlDocuments$ | async)"
					sourceId="{{ sourceId }}"
					class="h-full"
				></app-documents-word-matter-viewer>
			</ng-container>
			<app-document-matter-viewtor
				*ngIf="useHtmlDocuments$ | async"
				class="h-full"
				sourceId="req"
			></app-document-matter-viewtor>
		</div>
	</div>
</div>
